import * as React from "react";
import Svg, { G, Path, Circle } from "react-native-svg";

function SvgComponent({
  width,
  height,
  fillColor = "#CCCCCC",
  color = "#7E5C5B",
}) {
  return (
    <Svg
      width={width || "40px"}
      height={height || "40px"}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <G
        id="icons"
        stroke="none"
        stroke-width="1"
        fill="none"
        fill-rule="evenodd"
      >
        <G id="icon/black/time-with-circle">
          <Circle
            id="Oval"
            fill-opacity="0.5"
            fill={fillColor}
            cx="20"
            cy="20"
            r="20"
          ></Circle>
          <G
            id="icons8-delivery-time"
            transform="translate(9.000000, 9.000000)"
            fill={color}
            fill-rule="nonzero"
          >
            <Path
              d="M10.9999529,0 C4.93062558,0 0,4.92912054 0,10.9965952 C0,17.0640699 4.93062558,21.9931905 10.9999529,21.9931905 C14.4854056,21.9931905 17.5928397,20.3666095 19.6086117,17.8339822 L19.6086117,21.5150776 C19.6061724,21.6875023 19.6967908,21.8478831 19.8457672,21.934807 C19.9947437,22.021731 20.1789973,22.021731 20.3279738,21.934807 C20.4769502,21.8478831 20.5675686,21.6875023 20.5651293,21.5150776 L20.5651293,16.2558364 L19.8430704,16.2558364 L19.7954315,16.2558364 L15.3042823,16.2558364 C15.131805,16.2533979 14.9713752,16.3439886 14.8844247,16.4929196 C14.7974742,16.6418506 14.7974742,16.826048 14.8844247,16.9749789 C14.9713752,17.1239099 15.131805,17.2145006 15.3042823,17.2120621 L18.8818826,17.2120621 C17.0428454,19.5401317 14.200789,21.0369648 10.9999529,21.0369648 C5.44759084,21.0369648 0.956517643,16.5472625 0.956517643,10.9965952 C0.956517643,5.44592801 5.44759084,0.956225673 10.9999529,0.956225673 C16.5523149,0.956225673 21.0433881,5.44592801 21.0433881,10.9965952 C21.0409489,11.1690199 21.1315673,11.3294007 21.2805437,11.4163246 C21.4295202,11.5032486 21.6137738,11.5032486 21.7627502,11.4163246 C21.9117267,11.3294007 22.002345,11.1690199 21.9999538,10.9965952 C21.9999538,4.92912054 17.0692802,0 10.9999529,0 Z M10.9924801,3.34019475 C10.7287126,3.34437499 10.5180819,3.56120825 10.5216941,3.82490269 L10.5216941,9.64629988 C9.86590605,9.88115833 9.47361355,10.5529828 9.59149249,11.239326 C9.70937142,11.9256691 10.3033593,12.4282041 10.9999529,12.4309338 C11.6075909,12.4304771 12.1490487,12.04742 12.3515946,11.4747081 L16.2607999,11.4747081 C16.4332772,11.4771466 16.593707,11.3865559 16.6806575,11.2376249 C16.767608,11.0886939 16.767608,10.9044966 16.6806575,10.7555656 C16.593707,10.6066346 16.4332772,10.5160439 16.2607999,10.5184824 L12.3525286,10.5184824 C12.2080626,10.110098 11.8867208,9.78885432 11.4782117,9.64443238 L11.4782117,3.82490269 C11.479982,3.69566864 11.4293448,3.57122242 11.3378381,3.47991958 C11.2463314,3.38861674 11.12175,3.33823468 10.9924801,3.34019475 Z"
              id="Shape"
            ></Path>
          </G>
        </G>
      </G>
    </Svg>
  );
}

export default SvgComponent;
